
import { Component, Vue } from "vue-property-decorator";
import { rightsService } from "src/services";
import { Toast } from "vant";

@Component
export default class GoodsDetail extends Vue
{

    /**
     * 兑换账号和密码
     * @private
     * @returns any
     */
     private modelData: any =
    {
        cdNo: "",      // 账号
        cdKey: ""      // 密码
    };

    /**
     * 是否显示密码
     * @private
     * @returns string
     */
     private showPwd: boolean = false;

    /**
     * 主题配置
     * @private
     * @returns any
     */
    private get properties(): any
    {
        return this.$store.state.properties || {};
    }

    /**
     * 缓存的权益数据
     * @private
     * @returns any
     */
    private get rightsExchangeData(): any
    {
        return localStorage.getItem('rightsExchangeData') ? JSON.parse(localStorage.getItem('rightsExchangeData')) : {};
    }

    /**
     * 兑换
     * @private
     * @returns void
     */
     public async onExchange(): Promise<void>
    {
        // 未输入卡号和密码
        if(!this.modelData.cdNo || !this.modelData.cdKey) {
            return
        }
        if (this.onLogin()) {
            return;
        }
        try {
            let {content:res} = await rightsService.instance.rightsExchanged(this.modelData);
            Toast('兑换成功');
            localStorage.setItem('rightsExchangeData', null);
            this.$router.push({name: 'rights-redemption-success',query:{id:res.data}})

        } catch (error) {
            Toast(error)
        }
    }

    /**
     * 判断是否登入
     * @private
     * @returns void
     */
    private onLogin(): boolean
    {
        if (!localStorage.getItem("userInfo"))
        {
            // 若未登录，存储权益数据
            localStorage.setItem('rightsExchangeData', JSON.stringify(this.modelData));
            this.$router.push({name:"login", query:{redirect: location.href}});
            return true;
        }
    }

    // 钩子
    protected mounted() {
        setTimeout(()=>
        {
            let {cdNo, cdKey} = this.rightsExchangeData;
            if (cdNo && cdKey) {
                this.modelData.cdNo = cdNo;
                this.modelData.cdKey = cdKey;
            }
        }, 100);
    }
}
